import TitleWrap from '../../molecules/TitleWrap';
import AgreeWrap from '../../molecules/AgreeWrap';
import { Link } from 'react-router-dom';
import { WakeUp } from 'common/interface/props';
import styled from 'styled-components';
import { MdArrowForwardIos } from 'react-icons/md';

interface IProps {
  solType: WakeUp;
}

const LinkTitle = styled.div`
  font-size: 18px;
  color: #333;
  font-weight: 500;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-100%);
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  line-height: 18px;

  svg {
    width: 18px;
    height: 18px;
  }
`;

function CreateAccountAgree({ solType }: IProps) {
  return (
    <>
      {solType === 'ST11' ? (
        <div style={{ position: 'relative' }}>
          <TitleWrap title="약관동의" />
          <Link to="../login" relative="path">
            <LinkTitle>
              <span>이미 플레이오토 회원이시라면 로그인해 주세요</span>
              <MdArrowForwardIos size={18} />
            </LinkTitle>
          </Link>
        </div>
      ) : (
        <TitleWrap title="약관동의" />
      )}
      <AgreeWrap />
    </>
  );
}

export default CreateAccountAgree;
